document.addEventListener('click', function (event) {
  const tab = event.target.closest('.product-tabs__tab');
  if (!tab) return; // Click wasn't on a tab

  const tabsContainer = tab.closest('.product-tabs');
  if (!tabsContainer) return;

  const tabs = tabsContainer.querySelectorAll('.product-tabs__tab');
  const panels = tabsContainer.querySelectorAll('.product-tabs__panel');
  const target = tab.getAttribute('data-tab');

  // Update tab states
  tabs.forEach(function (t) {
    const isActive = t === tab;
    t.classList.toggle('is-active', isActive);
    t.setAttribute('aria-selected', isActive ? 'true' : 'false');
  });

  // Update panels
  panels.forEach(function (panel) {
    const match = panel.getAttribute('data-tab') === target;
    panel.classList.toggle('is-active', match);
    panel.hidden = !match;
  });
});
